import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
// import { GlobalContext } from "../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../../component/form/form-layout";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const CustomSelect = ({
  name,
  options,
  formik,
  placeholder,
  handleChangeExtra,
  disabled = false,
}) => {
  return (
    <Select
      name={name}
      className="text-sm"
      classNamePrefix="react-select"
      options={options}
      isDisabled={disabled}
      components={{
        IndicatorSeparator: () => null,
        LoadingIndicator: () => null,
      }}
      value={options?.find((opt) => opt?.value === formik.values[name])}
      onChange={(selectedOption) => {
        formik.setFieldValue(name, selectedOption?.value || "");
        if (handleChangeExtra) handleChangeExtra(selectedOption);
      }}
      filterOption={(option, inputValue) =>
        option?.label?.toLowerCase().includes(inputValue.toLowerCase())
      }
      placeholder={placeholder}
      isClearable
      menuPlacement="auto"
      styles={{
        control: (base, state) => ({
          ...base,
          minHeight: "35px",
          height: "auto",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          backgroundColor: state.isDisabled ? "#f0f0f0" : "#FFF",
          boxShadow: state.isFocused ? "none" : "none",
          "&:hover": { borderColor: "#DFDFDF" },
          fontSize: "13px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: "#1E1E1E",
          padding: "0 14px",
          cursor: state.isDisabled ? "not-allowed" : "normal",
        }),
        valueContainer: (base) => ({
          ...base,
          height: "auto",
          padding: "0 0px 0",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
          fontSize: "14px",
          height: "auto",
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
        }),
        placeholder: (base) => ({
          ...base,
          fontSize: "14px",
          color: "#717680",
        }),
        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
        menu: (base) => ({
          ...base,
          marginTop: "2px",
          borderRadius: "5px",
          border: "1px solid #DFDFDF",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }),
        option: (base, state) => ({
          ...base,
          fontSize: "14px",
          lineHeight: "1.2",
          fontWeight: 500,
          color: state.isSelected ? "#FFF" : "#1E1E1E",
          backgroundColor: state.isSelected
            ? "#3b82f6"
            : state.isFocused
            ? "#F3F4F6"
            : "#FFF",
          padding: "8px 14px",
          cursor: "pointer",
        }),
        indicatorContainer: (base) => ({ ...base, padding: 0 }),
        dropdownIndicator: (base) => ({ ...base, padding: 0 }),
      }}
    />
  );
};
const UpdateRenewalsStatus = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  editStatus = {},
  merchants = [],
  paymentMethods = [],
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  useEffect(() => {
    console.log("EDIt", editStatus);

    if (editStatus?.id) {
      formik.setFieldValue("renewal_status", editStatus?.renewal_status);
      formik.setFieldValue("billing_period", editStatus?.billing_period);
    }
  }, [editStatus]);

  const status = [
    {
      key: "Renewed",
      value: "renewed",
    },
    {
      key: "Due",
      value: "due",
    },
    {
      key: "Active",
      value: "active",
    },
    {
      key: "Expired",
      value: "expired",
    },
    {
      key: "Cancelled",
      value: "cancelled",
    },
  ];

  const timePeriod = [
    {
      key: "Monthly",
      value: "monthly",
    },
    {
      key: "Quarterly",
      value: "quarterly",
    },
    {
      key: "Yearly",
      value: "yearly",
    },
  ];

  const statusOptions = status?.map((each) => ({
    value: each.value,
    label: each.key,
  }));
  const timeOptions = timePeriod?.map((each) => ({
    value: each.value,
    label: each.key,
  }));

  const paymentOptions = paymentMethods?.map((pm) => ({
    value: pm.type_name,
    label: pm.type_name,
  }));

  const merchantsOptions = merchants?.map((m) => ({
    value: m.id,
    label: m.company_name,
  }));

  const isChanged = () => {
    if (!editStatus?.id) return true; // new data
    return Object.keys(formik.values).some(
      (key) => formik.values[key] !== editStatus[key]
    );
  };

  const validationSchema = yup.object({
    renewal_status: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    billing_period: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    merchant_id: yup.string().when("renewal_status", {
      is: (val) => val === "renewed",
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    transaction_key: yup.string().when("renewal_status", {
      is: (val) => val === "renewed",
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    payment_method: yup.string().when("renewal_status", {
      is: (val) => val === "renewed",
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    transaction_time: yup.string().when("renewal_status", {
      is: (val) => val === "renewed",
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    transaction_date: yup.date().when("renewal_status", {
      is: "renewed",
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      renewal_status: "",
      billing_period: "",
      merchant_id: "",
      transaction_key: "",
      payment_method: "",
      transaction_date: "",
      transaction_time: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!isChanged()) {
        console.log("No changes detected. API not called.");
        return;
      }
      let extraField = {};

      if (values?.renewal_status == "renewed") {
        extraField = {
          merchant_id: values?.merchant_id,
          transaction_key: values?.transaction_key,
          payment_method: values?.payment_method,
          transaction_date: values?.transaction_date,
          transaction_time: values?.transaction_time,
        };
      }
      let data = {
        ...extraField,
        renewal_status: values?.renewal_status,
        billing_period: values?.billing_period,
      };

      console.log("DATa", data);

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: `client-renewals/update-renewal-status/${editStatus?.id}`,
          data: data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response.data?.respMsg ||
            error?.response.data?.responseMessage ||
            error?.response.data?.message ||
            "Some Thing Went Wrong"
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>Edit Renewal Status</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* Renewal Status */}
                  <FeildWraper>
                    <FormLabel required>Renewal Status</FormLabel>

                    <SelectSearch
                      name="renewal_status"
                      placeholder="- Select Status -"
                      onChange={(val) => {
                        formik?.setFieldValue("renewal_status", val);
                      }}
                      value={formik?.values.renewal_status}
                      options={statusOptions}
                      onBlur={() =>
                        formik.setFieldTouched("renewal_status", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.renewal_status &&
                      formik.errors.renewal_status && (
                        <FeildError>{formik.errors.renewal_status}</FeildError>
                      )}
                  </FeildWraper>

                  {/* Billing Period */}

                  <FeildWraper>
                    <FormLabel required>Billing Period</FormLabel>

                    <SelectSearch
                      name="billing_period"
                      placeholder="- Select Billing Period -"
                      onChange={(val) => {
                        formik?.setFieldValue("billing_period", val);
                      }}
                      value={formik?.values.billing_period}
                      options={timeOptions}
                      onBlur={() =>
                        formik.setFieldTouched("billing_period", true, true)
                      }
                      menuPosition="fixed"
                    />
                    {formik.touched.billing_period &&
                      formik.errors.billing_period && (
                        <FeildError>{formik.errors.billing_period}</FeildError>
                      )}
                  </FeildWraper>

                  {formik.values.renewal_status == "renewed" && (
                    <>
                      {/* Transection key */}
                      <FeildWraper>
                        <FormLabel required>Transaction Key</FormLabel>
                        <input
                          type="text"
                          name="transaction_key"
                          value={formik.values.transaction_key}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          placeholder="Transaction key"
                        />
                        {formik.touched.transaction_key &&
                          formik.errors.transaction_key && (
                            <FeildError>
                              {formik.errors.transaction_key}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* Payment Method */}

                      <FeildWraper>
                        <FormLabel required>Payment Method</FormLabel>

                        <SelectSearch
                          name="payment_method"
                          placeholder="- Select Payment Method -"
                          onChange={(val) => {
                            formik?.setFieldValue("payment_method", val);
                          }}
                          value={formik?.values.payment_method}
                          options={paymentOptions}
                          onBlur={() =>
                            formik.setFieldTouched("payment_method", true, true)
                          }
                          menuPosition="fixed"
                        />
                        {formik.touched.payment_method &&
                          formik.errors.payment_method && (
                            <FeildError>
                              {formik.errors.payment_method}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* Merchants */}

                      <FeildWraper>
                        <FormLabel required>Merchant Name</FormLabel>

                        <SelectSearch
                          name="merchant_id"
                          placeholder="- Select Merchant -"
                          onChange={(val) => {
                            formik?.setFieldValue("merchant_id", val);
                          }}
                          value={formik?.values.merchant_id}
                          options={merchantsOptions}
                          onBlur={() =>
                            formik.setFieldTouched("merchant_id", true, true)
                          }
                          // menuPosition="fixed"
                        />
                        {formik.touched.merchant_id &&
                          formik.errors.merchant_id && (
                            <FeildError>{formik.errors.merchant_id}</FeildError>
                          )}
                      </FeildWraper>

                      {/* /* Transaction Date */}
                      <FeildWraper>
                        <FormLabel required>Transaction Date</FormLabel>
                        <input
                          type="date"
                          name="transaction_date"
                          value={formik.values.transaction_date}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                        />
                        {formik.touched.transaction_date &&
                          formik.errors.transaction_date && (
                            <FeildError>
                              {formik.errors.transaction_date}
                            </FeildError>
                          )}
                      </FeildWraper>

                      {/* Transaction Time */}
                      <FeildWraper width="100%">
                        <FormLabel required>Transaction Time</FormLabel>
                        <input
                          type="time"
                          name="transaction_time"
                          value={formik.values.transaction_time}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.transaction_time &&
                          formik.errors.transaction_time && (
                            <FeildError>
                              {formik.errors.transaction_time}
                            </FeildError>
                          )}
                      </FeildWraper>
                    </>
                  )}
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          {/* <button type="submit" className={Style.dcmb__submit}>
            Update
          </button> */}
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
            disabled={!isChanged()}
          >
            Update
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default UpdateRenewalsStatus;
